export interface IFilterMemberRole {
  name: string;
  id: number;
}

export const getMemberRoleAutocompleteFormattedValue = (value: IFilterMemberRole[]) => {
  return value.map(role => role.name).join(', ');
}
